var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticStyle:{"width":"1100px"},attrs:{"placeholder":"请选择"},model:{value:(_vm.notice),callback:function ($$v) {_vm.notice=$$v},expression:"notice"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.follow_desc,attrs:{"label":item.follow_desc,"value":item.follow_desc}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }